import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NavigationCancel } from '@angular/router';

import { AppComponent } from './../app.component';
import { HeaderComponent } from './../header/Header.component';
import { FooterComponent } from './../footer/Footer.component';
import { ContainerComponent } from './../container/Container.component';


const ALTSURVEY_ROUTES: Routes = [
  { path: '', redirectTo: 'AppComponent', pathMatch: 'full' },
  // { path: 'survey/:survey_name/:surveycode', component: AppComponent }

];

// @NgModule({
//   imports: [ RouterModule.forRoot(routes) ],
//   exports: [ RouterModule ]
// })


export const AppRoutingModule = RouterModule.forRoot(ALTSURVEY_ROUTES);
